// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ant-select-dropdown {\n    z-index: 9999999!important;\n}", "",{"version":3,"sources":["webpack://./src/pages/MainB2C/styles/index.css"],"names":[],"mappings":";AACA;IACI,0BAA0B;AAC9B","sourcesContent":["\n.ant-select-dropdown {\n    z-index: 9999999!important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
